import { TrendingDown, Brain, Layers, AlertTriangle } from "lucide-react";

const pains = [
  {
    icon: TrendingDown,
    title: "Salary Stuck for Years",
    text: "You see freshers with automation skills jumping 2x packages while your hike is just 5–10%. It hurts, and it's unfair.",
  },
  {
    icon: Brain,
    title: "Fear of Coding",
    text: "You open Selenium tutorials, see Java code, and close the tab. Feels like automation is only for 'developers'. It's not.",
  },
  {
    icon: Layers,
    title: "Tool Overload Confusion",
    text: "Selenium, Playwright, Cypress, Rest Assured, Postman, Cucumber… Which one should you actually learn first? Nobody tells you.",
  },
  {
    icon: AlertTriangle,
    title: "AI Replacing Manual Jobs",
    text: "Companies are automating regression suites every day. Manual-only testers are the first to get the silent cost-cut.",
  },
];

export default function Problem() {
  return (
    <section className="relative py-20 md:py-32 px-6 md:px-10" data-testid="problem-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <div className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#38BDF8]">
            The Hard Truth
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-normal text-white mt-4 leading-tight">
            Being a manual tester in 2026 is{" "}
            <span className="text-[#38BDF8]"> safe scary.</span>
          </h2>
          <p className="mt-6 text-lg text-slate-400 leading-relaxed">
            Every IT professional we train tells us the same story. Maybe one of these
            sounds like yours too.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-14">
          {pains.map((p, i) => (
            <div
              key={i}
              className="card-hover bg-slate-900/60 border border-slate-800 rounded-2xl p-7 md:p-8"
              data-testid={`pain-card-${i}`}
            >
              <div className="w-12 h-12 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center justify-center mb-5">
                <p.icon className="w-6 h-6 text-red-400" />
              </div>
              <h3 className="font-display text-2xl font-normal text-white">
                {p.title}
              </h3>
              <p className="mt-3 text-slate-400 leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
